import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import {Location} from '@angular/common';

import { AuthService } from '../services/auth.service';

@Injectable()
export class RoleGuard implements CanActivate, CanActivateChild {
  constructor(private authService: AuthService, private router: Router, private location: Location){}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let url: string = state.url;
    return this.checkUserLogin(route, url);
  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(next, state);
  }

  checkUserLogin(route: ActivatedRouteSnapshot, url: any): boolean {
    if (this.authService.isLoggedIn()) {
      /*const userRole: any = this.authService.getRole();
      const isAllowed = userRole.some((element: any) => {
        return route.data['role'] === element
      })
      if (route.data['role'] && !isAllowed) {
        console.log(this.location)
        this.location.back()
        //this.router.navigate(['/auth']);
        return false;
      }*/
      return true;
    }

    this.router.navigate(['/auth']);
    return false;
  }
  
}
